import {
  call,
  cancel,
  fork
} from 'redux-saga/effects'
import { delay } from 'Helper/customReduxEffects.js'
import _ from 'lodash'

let toolTipProcess
const tooltipPlacementAttribute = 'data-placement'
const tooltipAttribute = 'data-toggle'

export function * startToolTipManager(action) {
  if (!toolTipProcess) {
    toolTipProcess = yield fork(toolTipManager)
  }
}

export function * stopToolTipManager(action) {
  if (toolTipProcess) {
    yield cancel(toolTipProcess)
  }
}

function * toolTipManager() {
  // try {
  while (true) {
    yield delay(1000) // every second update tooltips
    yield call(manageToolTips)
  }
  // } catch (e) { }
}

const updateTooltip = (tooltipParent) => {
  const tooltipId = tooltipParent.getAttribute('tooltip-id')
  const tooltipContainer = document.querySelector(`#${tooltipId}`)
  if (!tooltipContainer) {
    // the owner of the tooltip isn't on the screen so just exit and the tooltip will get removed
    // elsewhere
    return
  }
  const tooltip = tooltipContainer.firstChild

  if (tooltipParent.title) {
    tooltip.innerHTML = tooltipParent.title
    tooltipParent.removeAttribute('title') // this disables browser tooltips
  } else if (tooltipParent.getAttribute('data-title') != null) {
    const text = tooltipParent.getAttribute('data-title')
    if (tooltip.innerHTML !== text) {
      tooltip.innerHTML = text
    }
  }

  let placement = tooltipParent.getAttribute(tooltipPlacementAttribute)
  const position = tooltipParent.getBoundingClientRect()

  if (!placement) {
    placement = 'right'
  } else {
    placement = placement.toLowerCase()
  }
  tooltip.classList.add(placement)

  const tooltipPosition = tooltipContainer.getBoundingClientRect()
  let top, left

  const margin = 5
  switch (placement) {
    case 'left':
      top = position.y + ((position.height / 2) - (tooltipPosition.height / 2))
      left = position.x - tooltipPosition.width - margin
      break
    case 'top':
      top = position.y - tooltipPosition.height - margin
      left = position.x + ((position.width / 2) - (tooltipPosition.width / 2))
      break
    case 'bottom':
      top = position.y + position.height + margin
      left = position.x + ((position.width / 2) - (tooltipPosition.width / 2))
      break
    case 'right':
    default:
      top = position.y + ((position.height / 2) - (tooltipPosition.height / 2))
      left = position.x + position.width + margin
  }
  if (top !== tooltipContainer.style.top) {
    tooltipContainer.style.top = top + 'px'
  }
  if (left !== tooltipContainer.style.left) {
    tooltipContainer.style.left = left + 'px'
  }
}

const createTooltip = tooltipParent => {
  // tipBox is a top level div that contains all tooltip containers
  let windowTipBox = document.querySelector('#window-tooltip-box')
  let modalTipBox = document.querySelector('#modal-tooltip-box')

  if (!windowTipBox) {
    const mainPanel = document.querySelector('.main-panel')
    windowTipBox = document.createElement('div')
    windowTipBox.id = 'window-tooltip-box'
    mainPanel.appendChild(windowTipBox)
  }

  if (!modalTipBox) {
    const mainPanel = document.querySelector('.main-panel')
    modalTipBox = document.createElement('div')
    modalTipBox.id = 'modal-tooltip-box'
    mainPanel.appendChild(modalTipBox)
  }

  if (!tooltipParent.childNodes || !([...tooltipParent.childNodes]).find(el => el.classList && el.classList.contains('tooltip-container'))) {
    tooltipParent.classList.add('tooltip-parent')

    const tooltipContainer = document.createElement('div')
    tooltipContainer.classList.add('tooltip-container')
    const tooltipId = _.uniqueId('tooltip-')
    tooltipContainer.id = tooltipId

    const tooltip = document.createElement('div')
    tooltip.classList.add('tooltip')

    tooltipContainer.appendChild(tooltip)

    if (tooltipParent.closest('.modal-content')) {
      // its a tooltip in a modal
      modalTipBox.appendChild(tooltipContainer)
    } else {
      // its a normal window/app tooltip
      windowTipBox.appendChild(tooltipContainer)
    }

    tooltipParent.setAttribute('tooltip-id', tooltipId)
    tooltipParent.onmouseover = () => {
      const tooltip = document.querySelector(`#${tooltipId}`)
      tooltip.classList.add('tooltip-visible')
    }
    tooltipParent.onmouseout = () => {
      const tooltip = document.querySelector(`#${tooltipId}`)
      tooltip.classList.remove('tooltip-visible')
    }
    tooltipParent.onclick = () => {
      const tooltip = document.querySelector(`#${tooltipId}`)
      tooltip.classList.remove('tooltip-visible')
    }

    updateTooltip(tooltipParent)
  }
}

function manageToolTips() {
  // update existing tooltips
  document.querySelectorAll(`.tooltip-parent[${tooltipAttribute}="tooltip"]`).forEach(updateTooltip)

  // create new tooltips
  document.querySelectorAll(`[${tooltipAttribute}="tooltip"]:not(.tooltip-parent)`).forEach(createTooltip)

  // remove tips whos parent no longer exists
  const windowTipBox = document.querySelector('#window-tooltip-box')
  if (windowTipBox) {
    ([...windowTipBox.childNodes]).forEach(tipContainer => {
      const parent = document.querySelector(`[tooltip-id="${tipContainer.id}"]`)
      if (!parent || parent.getAttribute('data-toggle') == null) {
        // there was no parent in the document or its data-toggle property was removed so remove the tip
        windowTipBox.removeChild(tipContainer)
        if (parent) {
          // if the parent is still there, remove the tooltip listeners
          parent.onmouseout = () => null
          parent.onmouseover = () => null
          parent.removeAttribute('tooltip-id')
          parent.classList.remove('tooltip-parent')
        }
      }
    })
  }
  const modalTipBox = document.querySelector('#modal-tooltip-box')
  if (modalTipBox) {
    ([...modalTipBox.childNodes]).forEach(tipContainer => {
      const parent = document.querySelector(`[tooltip-id="${tipContainer.id}"]`)
      if (!parent || parent.getAttribute('data-toggle') == null) {
        // there was no parent in the document or its data-toggle property was removed so remove the tip
        modalTipBox.removeChild(tipContainer)
        if (parent) {
          // if the parent is still there, remove the tooltip listeners
          parent.onmouseout = () => null
          parent.onmouseover = () => null
          parent.removeAttribute('tooltip-id')
          parent.classList.remove('tooltip-parent')
        }
      }
    })
  }
}
